<template>
  <div>
    <table-union-pager :data="tableData">
      <el-table-column prop="name" label="名称"/>
      <el-table-column label="图片">
        <template #default="scope">
          <el-image :src="scope.row.image" style="width: 60px;height: 60px;" :preview-src-list="[scope.row.image]"/>
        </template>
      </el-table-column>
      <el-table-column prop="points" label="分值"/>
      <el-table-column prop="remain" label="库存剩余"/>
      <el-table-column label="状态">
        <template #default="scope">
          <span v-if="scope.row.status === '1'">上架中</span>
          <span v-if="scope.row.status === '0'">未上架</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="text" icon="el-icon-edit">编辑</el-button>
          <el-button type="text">下架</el-button>
        </template>
      </el-table-column>
    </table-union-pager>
  </div>
</template>

<script>
import TableUnionPager from "@/components/TableUnionPager";

export default {
  name: "PointsExchange",
  components: {TableUnionPager},
  data() {
    return {
      tableData: {
        list: [],
        totalCount: 0,
        page: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    getPointsExchangeList(page) {
      this.tableData.list.push({
        name: '电水壶',
        image: 'http://biaoka-test.oss-cn-beijing.aliyuncs.com/20211209/6d32f556-2852-44f4-9a73-5c83878d84a8.png',
        points: '1888',
        remain: 10,
        status: '1'
      })
    }
  },
  mounted() {
    this.getPointsExchangeList(1);
  }
}
</script>

<style scoped>

</style>
